import React, { useContext } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import { createGlobalStyle } from 'styled-components';
// components
import { Faqs } from 'components/Faqs';
import { ParticipantsListMobile } from 'components/Participants';
import { EventParticipantDetail } from 'components/Participants/EventParticipantDetail';
import { PrintParticipants } from 'components/Participants/PrintParticipants';
import { TicketsListMobile } from 'components/Participants/TicketsListMobile';
import {
  RegistrationsDesktop,
  RegistrationsMobile,
} from 'components/Registrations';
import ThemeProvider from 'components/ThemeProvider';
import { TicketDetails } from 'components/Transactions/TransactionModal/TicketDetails';
import useWindowSize from 'hooks/useWindowSize';
// app admin
import Account from 'pages/app/Account';
import AccountAnnualsHub from 'pages/app/Accounts/AccountAnnualsHub';
import AccountEvents from 'pages/app/Accounts/AccountEvents';
import AccountReport from 'pages/app/Accounts/AccountReport';
import Accounts from 'pages/app/Accounts/AccountsPage/index';
import AddAccountsV2 from 'pages/app/Accounts/AddAccounts/AddAccountsV2';
import EditCapabilities from 'pages/app/Accounts/AddAccounts/components/StaffTab/EditCapabilities';
import AddTicketTemplate from 'pages/app/Accounts/AddAccounts/components/TicketsTab/AddTicketTemplate';
import EditTicketTemplate from 'pages/app/Accounts/AddAccounts/components/TicketsTab/EditTicketTemplate';
import CreateAccountV2 from 'pages/app/Accounts/AddAccounts/CreateAccountV2';
import AddAnnualTicket from 'pages/app/AnnualTickets/AddAnnualTicket';
import AnnualsPage from 'pages/app/AnnualTickets/Annuals/AnnualsPage';
import AnnualDetail from 'pages/app/AnnualTickets/Annuals/MemberDetail/MemberDetail';
import AnnualsAccount from 'pages/app/AnnualTickets/Annuals/MembersAccount';
import AnnualTicketsPage from 'pages/app/AnnualTickets/AnnualTicketsPage';
import AddCategory from 'pages/app/AnnualTickets/Categories/AddCategory';
import CategoriesPage from 'pages/app/AnnualTickets/Categories/CategoriesPage';
import EditCategory from 'pages/app/AnnualTickets/Categories/EditCategory';
import EditAnnualTicket from 'pages/app/AnnualTickets/EditAnnualTicket';
import TransferMembership from 'pages/app/AnnualTickets/Members/MemberDetail/Components/TransferMembership';
import MemberDetail from 'pages/app/AnnualTickets/Members/MemberDetail/MemberDetail';
import MembersAccount from 'pages/app/AnnualTickets/Members/MembersAccount';
import MembersPage from 'pages/app/AnnualTickets/Members/MembersPage';
import PurchaseDetailPage from 'pages/app/AnnualTickets/Purchases/PurchaseDetailPage';
import PurchasesPage from 'pages/app/AnnualTickets/Purchases/PurchasesPage';
import CartPage from 'pages/app/Cart';
import { BoxOfficeReport } from 'pages/app/Cart/Components/BoxOfficeReport';
import { CashDrawerReport } from 'pages/app/Cart/Components/CashDrawerReport';
import { PosSettings } from 'pages/app/Cart/Components/PosSettings';
import Categories from 'pages/app/Categories/Categories';
import Credits from 'pages/app/Credits';
import CreditsMobile from 'pages/app/Credits/CreditMobile/CreditsMobile';
import ExpiredCreditDetailMobile from 'pages/app/Credits/CreditMobile/ExpiredCreditsMobile/ExpiredCreditDetailMobile';
import ExpiredCreditMobile from 'pages/app/Credits/CreditMobile/ExpiredCreditsMobile/ExpiredCreditMobile';
import FinancialsMobile from 'pages/app/Credits/CreditMobile/FinancialsMobile/FinancialsMobile';
import OpenCreditsDetailMobile from 'pages/app/Credits/CreditMobile/OpenCreditMobile/OpenCreditsDetailMobile';
import OpenCreditsMobile from 'pages/app/Credits/CreditMobile/OpenCreditMobile/OpenCreditsMobile';
import RedeemedCreditDetailMobile from 'pages/app/Credits/CreditMobile/RedeemedCreditsMobile/RedeemedCreditDetailMobile';
import RedeemedCreditMobile from 'pages/app/Credits/CreditMobile/RedeemedCreditsMobile/RedeemedCreditMobile';
import ExpiredCredits from 'pages/app/Credits/ExpiredCredits/ExpiredCredits';
import ExpiredCreditsDetail from 'pages/app/Credits/ExpiredCredits/ExpiredCreditsDetail';
import Financials from 'pages/app/Credits/Financials/Financials';
import OpenCredits from 'pages/app/Credits/OpenCredits/OpenCredits';
import OpenCreditsDetail from 'pages/app/Credits/OpenCredits/OpenCreditsDetail';
import RedeemedCredits from 'pages/app/Credits/RedeemedCredits/RedeemedCredits';
import RedeemedCreditsDetail from 'pages/app/Credits/RedeemedCredits/RedeemedCreditsDetail';
import EventDetails from 'pages/app/Events/EventDetails';
import { EventsMenu } from 'pages/app/Events/EventsMenu';
import { RefundEventFlow } from 'pages/app/Events/EventsMenu/components/RefundEventFlow';
import { ReservedSeats } from 'pages/app/Events/EventsMenu/components/ReservedSeats';
import { EventsReport } from 'pages/app/Events/EventsReport';
import AppReport from 'pages/app/Events/EventsReport/Reports/AppReport';
import CashReport from 'pages/app/Events/EventsReport/Reports/CashReport';
import { LapSponsorshipReport } from 'pages/app/Events/EventsReport/Reports/LapSponsorshipReport';
import PosCardReport from 'pages/app/Events/EventsReport/Reports/PosCardReport';
import PosCashReport from 'pages/app/Events/EventsReport/Reports/PosCashReport';
import ScanLogReport from 'pages/app/Events/EventsReport/Reports/ScanLogReport';
import TicketBreakdownReport from 'pages/app/Events/EventsReport/Reports/TicketBreakdownReport';
import EventsV3 from 'pages/app/Events/EventsV3';
import { FaqsAdmin } from 'pages/app/Faqs';
import Infos from 'pages/app/Infos';
import ApprovedUsers from 'pages/app/NewUsers/ApprovedUsers/ApprovedUsers';
import ApproveUser from 'pages/app/NewUsers/ApproveUser/ApproveUser';
import TemporaryUsers from 'pages/app/NewUsers/TemporaryUsers/TemporaryUsers';
import Notifications from 'pages/app/Notifications';
import Participants from 'pages/app/Participants';
import PayoutsPage from 'pages/app/Payouts';
import Promos from 'pages/app/Promos';
import PromoDetail from 'pages/app/Promos/PromoDetail';
import AccountRefunds from 'pages/app/Refunds';
import {
  RegistrationsEventsDesktop,
  RegistrationsEventsMobile,
} from 'pages/app/Registrations';
import { Reports } from 'pages/app/Reports';
import Series from 'pages/app/Series';
import SeriesEdit from 'pages/app/Series/EditSeries';
import SeriesTypes from 'pages/app/SeriesTypes';
import { StripeRedirect } from 'pages/app/Stripe';
import { StripeConnectRefresh } from 'pages/app/Stripe/StripeConnectRefresh';
import { StripeConnectReturn } from 'pages/app/Stripe/StripeConnectReturn';
import TextLists from 'pages/app/TextLists';
import Tickets from 'pages/app/Tickets';
import Tracks from 'pages/app/Tracks';
import { TrackEdit } from 'pages/app/Tracks/TrackEdit';
import TrackTypes from 'pages/app/TrackTypes';
import TransactionsEvents from 'pages/app/Transactions/';
import MobileAdminTransactions from 'pages/app/Transactions/mobileTransactions';
import TransactionDetailNew from 'pages/app/Transactions/TransactionDetail/TransactionDetailNew';
import Transactions from 'pages/app/Transactions/transactionsList';
import Users from 'pages/app/Users';
import UserTransactions from 'pages/app/Users/transactions';
import UserEdit from 'pages/app/Users/UserEdit';
import Waivers from 'pages/app/Waivers';
// auth
import Auth from 'pages/Auth';
import ForgotPassword from 'pages/Auth/ForgotPassword';
import PromoterSignup from 'pages/Auth/PromoterSignup';
import { SignupProvider } from 'pages/Auth/PromoterSignup/context/SignupContext';
import BusinessDetailsStep from 'pages/Auth/PromoterSignup/steps/BusinessDetailsStep';
import MailingAddressStep from 'pages/Auth/PromoterSignup/steps/MailingAddressStep';
import ReviewStep from 'pages/Auth/PromoterSignup/steps/ReviewStep';
import ShippingAddressStep from 'pages/Auth/PromoterSignup/steps/ShippingAddressStep';
import StripeSetupStep from 'pages/Auth/PromoterSignup/steps/StripeSetupStep';
import SuccessStep from 'pages/Auth/PromoterSignup/steps/SuccessStep';
import TermsStep from 'pages/Auth/PromoterSignup/steps/TermsStep';
import TrackAddressStep from 'pages/Auth/PromoterSignup/steps/TrackAddressStep';
import UserInfoStep from 'pages/Auth/PromoterSignup/steps/UserInfoStep';
import WelcomeStep from 'pages/Auth/PromoterSignup/steps/WelcomeStep';
import SetPassword from 'pages/Auth/SetPassword';
import TrackLogIn from 'pages/Auth/track-log-in';
import VerifyPassword from 'pages/Auth/VerifyPassword';
// employee admin
import ScanEmployee from 'pages/employee/Scan';
import LearningHub from 'pages/LearningHub';
import LearningHubAdmin from 'pages/LearningHubAdmin';
// track admin
import StyleGuide from 'pages/StyleGuide';
import TrackContact from 'pages/track/Contact';
import TrackFinancials from 'pages/track/CreditTrack/Financials/TrackFinancials';
import TrackExpiredCredits from 'pages/track/CreditTrack/TrackExpiredCredits/TrackExpiredCredits';
import TrackExpiredCreditsDetail from 'pages/track/CreditTrack/TrackExpiredCredits/TrackExpiredCreditsDetail';
import TrackOpenCredits from 'pages/track/CreditTrack/TrackOpenCredit/TrackOpenCredits';
import TrackOpenCreditsDetail from 'pages/track/CreditTrack/TrackOpenCredit/TrackOpenCreditsDetail';
import TrackRedeemedCredits from 'pages/track/CreditTrack/TrackRedeemedCredits/TrackRedeemedCredits';
import TrackRedeemedCreditsDetail from 'pages/track/CreditTrack/TrackRedeemedCredits/TrackRedeemedCreditsDetail';
import TrackExpiredCreditDetailMobile from 'pages/track/CreditTrackMobile/TrackExpiredCreditsMobile/TrackExpiredCreditDetailMobile';
import TrackExpiredCreditMobile from 'pages/track/CreditTrackMobile/TrackExpiredCreditsMobile/TrackExpiredCreditMobile';
import TrackFinancialsMobile from 'pages/track/CreditTrackMobile/TrackFinancialsMobile/TrackFinancialsMobile';
import TrackOpenCreditDetailMobile from 'pages/track/CreditTrackMobile/TrackOpenCreditMobile/TrackOpenCreditDetailMobile';
import TrackOpenCreditMobile from 'pages/track/CreditTrackMobile/TrackOpenCreditMobile/TrackOpenCreditMobile';
import TrackRedeemedCreditDetailMobile from 'pages/track/CreditTrackMobile/TrackRedeemedCreditsMobile/TrackRedeemedCreditDetailMobile';
import TrackRedeemedCreditMobile from 'pages/track/CreditTrackMobile/TrackRedeemedCreditsMobile/TrackRedeemedCreditMobile';
import Customers from 'pages/track/Customers';
import IssueCredit from 'pages/track/Customers/components/IssueCredit';
import SendCampaign from 'pages/track/Customers/components/SendCampaign';
import TransactionCredit from 'pages/track/Customers/components/TransactionCredit';
import CustomerDetail from 'pages/track/Customers/CustomerDetail';
import EmployeesTrack from 'pages/track/Employees';
import EmployeeDetail from 'pages/track/Employees/EmployeeDetail';
import { EmployeeEdit } from 'pages/track/Employees/EmployeeEdit';
import EmployeeList from 'pages/track/Employees/EmployeeMobile/employeeList';
import { GuestListDesktop } from 'pages/track/GuestList/EventGuestList/Desktop';
import { GuestListMobile } from 'pages/track/GuestList/EventGuestList/Mobile';
import GuestEvents from 'pages/track/GuestList/GuestListEvents';
import GuestEventsMobile from 'pages/track/GuestList/GuestListEventsMobile';
import { Guests } from 'pages/track/Guests';
import { GuestDetail } from 'pages/track/Guests/GuestDetail';
import { TrackHome } from 'pages/track/Home';
import MobileTransactions from 'pages/track/MobileTransactions';
import { MobileTransactionsList } from 'pages/track/MobileTransactions/transactionsList';
import TrackNotifications from 'pages/track/Notifications';
import {
  TrackRegistrationsEventsDesktop,
  TrackRegistrationsEventsMobile,
} from 'pages/track/Registrations';
import { SetTrackPassword } from 'pages/track/SignUp';
import { SetStripe } from 'pages/track/SignUp/setStripe';
import TermsOfService from 'pages/track/TermsOfService';
import TrackTransactionsEvents from 'pages/track/Transactions';
import TrackVideos from 'pages/track/Videos';
import TrackVideosMobile from 'pages/track/Videos/videosMobile';
import TrackWeather from 'pages/track/Weather';
import { AppContext } from 'shared/AppContext';
import storage from 'shared/storage';
import Apollo from '../apollo';
import ApolloMainAdmin from '../apolloMainAdmin';
// layouts
import CreateEventV2 from '../pages/app/Events/CreateEventV2';
import CreateEventFinish from '../pages/app/Events/CreateEventV2/CreateEventFinish';
import CreateEventTickets from '../pages/app/Events/CreateEventV2/CreateEventTickets';
import EditEventV2 from '../pages/app/Events/EditEventV2';
import AddEventTicket from '../pages/app/Events/EditEventV2/AddEventTicket';
import EditEventTicket from '../pages/app/Events/EditEventV2/EditEventTicket';
import AdminRoute from './AdminRoute';
import AuthRoute from './AuthRoute';
import EmployeeRoute from './EmployeeRoute';
import TrackAdminRoute from './TrackAdminRoute';

// Wrapper components for refund routes
const IssueRefund = (props) => <IssueCredit {...props} type="refund" />;
const TransactionRefund = (props) => (
  <TransactionCredit {...props} type="refund" />
);

// Wrapper for promoter signup routes to provide SignupContext
// Note: Using plain Route (not AuthRoute) to avoid AuthLayout's orange background
const PromoterSignupRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => (
      <SignupProvider>
        <Component {...props} />
      </SignupProvider>
    )}
  />
);

const GlobalStyle = createGlobalStyle`
body {
  background-color: ${(props) =>
    'light' === props.appTheme
      ? 768 > props.width
        ? props.theme.colors.primary
        : props.theme.colors.secondary
      : props.theme.colors.secondary};
}
`;

const AppRouter = () => {
  const [width] = useWindowSize();
  const { state } = useContext(AppContext);

  const renderAuthScreen = (props) => {
    const user = storage.get('user', {});
    if (user.role === 'admin') return <Redirect to="/admin/users" />;
    if (user.role === 'track') return <Redirect to="/admin-track/home" />;
    if (user.role === 'employee') return <Redirect to="/admin-employee/home" />;
    return (
      <ApolloMainAdmin>
        <Auth {...props} />
      </ApolloMainAdmin>
    );
  };

  return (
    <Apollo>
      <ThemeProvider>
        <Router>
          <Switch>
            {/* Auth */}
            <Route exact path="/" render={renderAuthScreen} />
            <Route exact path="/login" render={renderAuthScreen} />
            <Route exact path="/login/phone" render={renderAuthScreen} />
            <Route exact path="/login/verify" render={renderAuthScreen} />
            <Route exact path="/login/email" render={renderAuthScreen} />
            <AuthRoute
              exact
              path="/forgot-password"
              component={ForgotPassword}
            />
            {/* Promoter Signup - New modern steps (must come before general /promoter-signup route) */}
            <PromoterSignupRoute
              exact
              path="/promoter-signup/welcome"
              component={WelcomeStep}
            />
            <PromoterSignupRoute
              exact
              path="/promoter-signup/user-info"
              component={UserInfoStep}
            />
            <PromoterSignupRoute
              exact
              path="/promoter-signup/business-details"
              component={BusinessDetailsStep}
            />
            <PromoterSignupRoute
              exact
              path="/promoter-signup/track-address"
              component={TrackAddressStep}
            />
            <PromoterSignupRoute
              exact
              path="/promoter-signup/shipping-address"
              component={ShippingAddressStep}
            />
            <PromoterSignupRoute
              exact
              path="/promoter-signup/mailing-address"
              component={MailingAddressStep}
            />
            <PromoterSignupRoute
              exact
              path="/promoter-signup/terms"
              component={TermsStep}
            />
            <PromoterSignupRoute
              exact
              path="/promoter-signup/review"
              component={ReviewStep}
            />
            <PromoterSignupRoute
              exact
              path="/promoter-signup/success"
              component={SuccessStep}
            />
            <PromoterSignupRoute
              exact
              path="/promoter-signup/stripe-setup"
              component={StripeSetupStep}
            />
            {/* Promoter Signup - Old phone/verify screens.
                No logged-in redirect here: existing users (track, employee,
                user) must be able to enter this flow to create an account. */}
            <Route
              path="/promoter-signup"
              render={(props) => (
                <ApolloMainAdmin>
                  <PromoterSignup {...props} />
                </ApolloMainAdmin>
              )}
            />
            <AuthRoute
              exact
              path="/verify-password"
              component={VerifyPassword}
            />
            <AuthRoute path="/stripe" component={SetStripe} />
            <AuthRoute
              path="/track-sign-up"
              exact
              component={SetTrackPassword}
            />
            <AuthRoute path="/track-log-in" exact component={TrackLogIn} />
            <AuthRoute
              backgroundColor="#fff"
              exact
              path="/set-password"
              component={SetPassword}
            />
            {/* Super Admin */}
            <AdminRoute exact path="/admin/settings" component={Account} />
            <AdminRoute path="/admin/style-guide" component={StyleGuide} />
            <AdminRoute
              exact
              path="/admin/events/addEvent"
              component={CreateEventV2}
            />
            <AdminRoute
              exact
              path="/admin/events/addEvent/:eventId/tickets"
              component={CreateEventTickets}
            />
            <AdminRoute
              exact
              path="/admin/events/addEvent/:eventId/finish"
              component={CreateEventFinish}
            />
            <AdminRoute
              exact
              path="/admin/events/editEvent/:eventId/tickets/add"
              component={AddEventTicket}
            />
            <AdminRoute
              exact
              path="/admin/events/editEvent/:eventId/tickets/:ticketId/edit"
              component={EditEventTicket}
            />
            <AdminRoute
              exact
              path="/admin/events/editEvent/:id"
              component={EditEventV2}
            />
            <AdminRoute
              exact
              path="/admin/track/events/:id"
              component={(props) => <EventsV3 {...props} />}
            />
            <AdminRoute
              exact
              path="/admin/weather/:trackId"
              component={TrackWeather}
            />
            <AdminRoute
              exact
              path="/admin/annualTickets"
              component={AnnualTicketsPage}
            />
            <AdminRoute
              exact
              path="/admin/annualcategories/add"
              component={AddCategory}
            />
            <AdminRoute
              exact
              path="/admin/annualcategories/edit/:id"
              component={EditCategory}
            />
            <AdminRoute
              exact
              path="/admin/annualcategories"
              component={CategoriesPage}
            />
            <AdminRoute
              exact
              path="/admin/annualTickets/add"
              component={AddAnnualTicket}
            />
            <AdminRoute
              exact
              path="/admin/editAnnualTicket/:id"
              component={EditAnnualTicket}
            />
            <AdminRoute
              exact
              path="/admin/annualPurchases"
              component={PurchasesPage}
            />
            <AdminRoute
              exact
              path="/admin/annualPurchases/purchase/:id"
              component={PurchaseDetailPage}
            />
            <AdminRoute
              exact
              path="/admin/annualMembersAccount"
              component={MembersAccount}
            />
            <AdminRoute
              exact
              path="/admin/annualMembers/:id/:name"
              component={MembersPage}
            />
            <AdminRoute
              exact
              path="/admin/annualMembersDetail/member/:id"
              component={MemberDetail}
            />
            <AdminRoute
              exact
              path="/admin/transferMembership/:id"
              component={TransferMembership}
            />
            <AdminRoute
              exact
              path="/admin/annualsAccount"
              component={AnnualsAccount}
            />
            <AdminRoute
              exact
              path="/admin/annualUsers/:id/:name"
              component={AnnualsPage}
            />
            <AdminRoute
              exact
              path="/admin/annualsDetail/member/:id"
              component={AnnualDetail}
            />
            <AdminRoute
              exact
              path="/admin/annualDetail/annual/:id"
              component={AnnualDetail}
            />
            <AdminRoute
              exact
              path="/admin/series/events/:id"
              component={(props) => <EventsV3 {...props} />}
            />
            <AdminRoute
              exact
              path="/admin/track/:track_id/events/:id/participants"
              component={
                process.env.REACT_APP_PLATFORM !== 'tickethoss'
                  ? Participants
                  : Tickets
              }
            />
            <AdminRoute
              exact
              path="/admin/track/:track_id/events/:id/participants/:userId"
              component={(props) =>
                process.env.REACT_APP_PLATFORM !== 'tickethoss' ? (
                  <EventParticipantDetail {...props} />
                ) : (
                  <TicketDetails {...props} />
                )
              }
            />
            <AdminRoute
              exact
              path="/admin/series/:track_id/events/:id/participants/:userId"
              component={(props) =>
                process.env.REACT_APP_PLATFORM !== 'tickethoss' ? (
                  <EventParticipantDetail {...props} />
                ) : (
                  <TicketDetails {...props} />
                )
              }
            />
            <AdminRoute
              exact
              path="/admin/series/:track_id/events/:id/participants"
              component={(props) =>
                process.env.REACT_APP_PLATFORM !== 'tickethoss' ? (
                  width > 860 ? (
                    <Participants {...props} />
                  ) : (
                    <ParticipantsListMobile {...props} />
                  )
                ) : width > 860 ? (
                  <Tickets {...props} />
                ) : (
                  <TicketsListMobile {...props} />
                )
              }
            />
            <AdminRoute
              exact
              path="/admin/events/upcoming"
              component={(props) => <EventsV3 {...props} filter="upcoming" />}
            />
            <AdminRoute
              exact
              path="/admin/events/past"
              component={(props) => <EventsV3 {...props} filter="past" />}
            />
            <AdminRoute
              exact
              path="/admin/events/drafts"
              component={(props) => <EventsV3 {...props} filter="drafts" />}
            />
            <AdminRoute
              exact
              path="/admin/events/:id"
              component={EventDetails}
            />
            <AdminRoute exact path="/admin/faqs" component={FaqsAdmin} />
            <AdminRoute exact path="/admin/infos" component={Infos} />
            <AdminRoute exact path="/admin/categories" component={Categories} />
            <AdminRoute
              exact
              path="/admin/notifications"
              component={Notifications}
            />
            <AdminRoute exact path="/admin/promos" component={Promos} />
            <AdminRoute
              exact
              path="/admin/promos/:promo_id"
              component={PromoDetail}
            />
            <AdminRoute exact path="/admin/reports" component={Reports} />
            <AdminRoute exact path="/admin/series" component={Series} />
            <AdminRoute exact path="/admin/tracks" component={Tracks} />
            <AdminRoute
              exact
              path="/admin/tracks/editTrack/:id"
              component={TrackEdit}
            />
            <AdminRoute
              exact
              path="/admin/tracks/addTrack"
              component={TrackEdit}
            />
            <AdminRoute
              exact
              path="/admin/series/editSeries/:id"
              component={SeriesEdit}
            />
            <AdminRoute
              exact
              path="/admin/series/addSeries"
              component={SeriesEdit}
            />
            <AdminRoute exact path="/admin/accounts" component={Accounts} />
            <AdminRoute
              exact
              path="/admin/account/:accountId/events"
              component={AccountEvents}
            />
            <AdminRoute
              exact
              path="/admin/accounts/:accountId/annuals"
              component={AccountAnnualsHub}
            />
            <AdminRoute
              exact
              path="/admin/accounts/addAccount"
              component={CreateAccountV2}
            />
            <AdminRoute
              exact
              path="/admin/accounts/editAccount/:accountId/staff/:id/capabilities"
              component={EditCapabilities}
            />
            <AdminRoute
              exact
              path="/admin/accounts/editAccount/:id/tickets/add"
              component={AddTicketTemplate}
            />
            <AdminRoute
              exact
              path="/admin/accounts/editAccount/:id/tickets/:templateId/edit"
              component={EditTicketTemplate}
            />
            <AdminRoute
              exact
              path="/admin/accounts/editAccount/:id"
              component={AddAccountsV2}
            />
            <AdminRoute
              exact
              path="/admin/accounts/reports/:id"
              component={AccountReport}
            />
            <AdminRoute
              exact
              path="/admin/accounts/refunds/:id"
              component={AccountRefunds}
            />
            <AdminRoute exact path="/admin/payouts" component={PayoutsPage} />
            <AdminRoute exact path="/admin/users" component={Users} />
            <AdminRoute
              exact
              path="/admin/temporaryUsers"
              component={TemporaryUsers}
            />
            <AdminRoute
              exact
              path="/admin/temporaryUsers/:id"
              component={ApproveUser}
            />
            <AdminRoute
              exact
              path="/admin/approvedUsers"
              component={ApprovedUsers}
            />
            <AdminRoute
              exact
              path="/admin/users/transactions/:id"
              component={UserTransactions}
            />
            <AdminRoute
              exact
              path="/admin/transactions/detail/:id"
              component={TransactionDetailNew}
            />
            <AdminRoute
              exact
              path="/admin/transactions/:transactionId/credit"
              component={TransactionCredit}
            />
            <AdminRoute
              exact
              path="/admin/transactions/:transactionId/refund"
              component={TransactionRefund}
            />
            <AdminRoute
              exact
              path="/admin/users/addUser"
              component={UserEdit}
            />
            <AdminRoute
              exact
              path="/admin/users/editUser/:id"
              component={UserEdit}
            />
            <AdminRoute
              exact
              path="/admin/users/edit/:id"
              component={UserEdit}
            />
            <AdminRoute
              exact
              path="/admin/users/issue-credit/:customerId"
              component={IssueCredit}
            />
            <AdminRoute
              exact
              path="/admin/learning-hub"
              component={LearningHub}
            />
            <AdminRoute
              path="/admin/learning-hub-admin"
              component={LearningHubAdmin}
            />
            <AdminRoute exact path="/admin/stripe" component={StripeRedirect} />
            <Route
              exact
              path="/connect/refresh"
              component={StripeConnectRefresh}
            />
            <Route
              exact
              path="/connect/return"
              component={StripeConnectReturn}
            />
            <AdminRoute
              exact
              path="/admin/track-types"
              component={TrackTypes}
            />
            <AdminRoute
              exact
              path="/admin/series-types"
              component={SeriesTypes}
            />
            <AdminRoute exact path="/admin/text-lists" component={TextLists} />
            <AdminRoute
              exact
              path="/admin/openCredits"
              component={(props) =>
                width > 860 ? (
                  <Credits {...props} />
                ) : (
                  <CreditsMobile {...props} />
                )
              }
            />
            <AdminRoute
              exact
              path="/admin/redeemedCredits"
              component={(props) =>
                width > 860 ? (
                  <Credits {...props} />
                ) : (
                  <CreditsMobile {...props} />
                )
              }
            />
            <AdminRoute
              exact
              path="/admin/expiredCredits"
              component={(props) =>
                width > 860 ? (
                  <Credits {...props} />
                ) : (
                  <CreditsMobile {...props} />
                )
              }
            />
            <AdminRoute
              exact
              path="/admin/financials"
              component={(props) =>
                width > 860 ? (
                  <Credits {...props} />
                ) : (
                  <CreditsMobile {...props} />
                )
              }
            />
            <AdminRoute
              exact
              path="/admin/openCredits/:id"
              component={(props) =>
                width > 860 ? (
                  <OpenCredits {...props} />
                ) : (
                  <OpenCreditsMobile {...props} />
                )
              }
            />
            <AdminRoute
              exact
              path="/admin/openCredits/creditDetail/:id"
              component={(props) =>
                width > 860 ? (
                  <OpenCreditsDetail {...props} />
                ) : (
                  <OpenCreditsDetailMobile {...props} />
                )
              }
            />
            <AdminRoute
              exact
              path="/admin/openCredits/:id/creditDetail/:id2"
              component={(props) =>
                width > 860 ? (
                  <OpenCreditsDetail {...props} />
                ) : (
                  <OpenCreditsDetailMobile {...props} />
                )
              }
            />
            <AdminRoute
              exact
              path="/admin/redeemedCredits/:id"
              component={(props) =>
                width > 860 ? (
                  <RedeemedCredits {...props} />
                ) : (
                  <RedeemedCreditMobile {...props} />
                )
              }
            />
            <AdminRoute
              exact
              path="/admin/expiredCredits/:id"
              component={(props) =>
                width > 860 ? (
                  <ExpiredCredits {...props} />
                ) : (
                  <ExpiredCreditMobile {...props} />
                )
              }
            />
            <AdminRoute
              exact
              path="/admin/redeemedCredits/:id/creditDetail/:id2"
              component={(props) =>
                width > 860 ? (
                  <RedeemedCreditsDetail {...props} />
                ) : (
                  <RedeemedCreditDetailMobile {...props} />
                )
              }
            />
            <AdminRoute
              exact
              path="/admin/expiredCredits/:id/creditDetail/:id2"
              component={(props) =>
                width > 860 ? (
                  <ExpiredCreditsDetail {...props} />
                ) : (
                  <ExpiredCreditDetailMobile {...props} />
                )
              }
            />
            <AdminRoute
              exact
              path="/admin/financials/:id"
              component={(props) =>
                width > 860 ? (
                  <Financials {...props} />
                ) : (
                  <FinancialsMobile {...props} />
                )
              }
            />
            <AdminRoute exact path="/admin/waivers" component={Waivers} />
            <AdminRoute exact path="/admin/scan/:id" component={ScanEmployee} />
            <AdminRoute
              exact
              path="/admin/transactions"
              component={(props) =>
                width > 860 ? (
                  <TransactionsEvents {...props} />
                ) : (
                  <MobileAdminTransactions {...props} />
                )
              }
            />
            <AdminRoute
              exact
              path="/admin/transactions/event/:id"
              component={(props) =>
                width > 860 ? (
                  <Transactions {...props} />
                ) : (
                  <MobileTransactionsList {...props} />
                )
              }
            />
            <AdminRoute
              exact
              path="/admin/registrations"
              component={(props) =>
                width > 860 ? (
                  <RegistrationsEventsDesktop {...props} />
                ) : (
                  <RegistrationsEventsMobile {...props} />
                )
              }
            />
            <AdminRoute
              exact
              path="/admin/registrations/event/:id"
              component={(props) =>
                width > 860 ? (
                  <RegistrationsDesktop {...props} />
                ) : (
                  <RegistrationsMobile {...props} />
                )
              }
            />
            <AdminRoute
              exact
              path="/admin/registrationDetail/registration/:id"
              component={MemberDetail}
            />
            <AdminRoute exact path="/admin/cart/:id" component={CartPage} />
            <AdminRoute
              exact
              path="/admin/events/menu/:id"
              component={(props) => <EventsMenu {...props} />}
            />
            <AdminRoute
              exact
              path="/admin/events/reports/:id"
              component={(props) => <EventsReport {...props} />}
            />
            <AdminRoute
              exact
              path="/admin/events/reports/cash-report/:id"
              component={(props) => <CashReport {...props} />}
            />
            <AdminRoute
              exact
              path="/admin/events/refund/:id"
              component={(props) => (
                <RefundEventFlow {...props} isVisible={true} />
              )}
            />
            <AdminRoute
              exact
              path="/admin/events/reservedSeats/:id"
              component={(props) => <ReservedSeats {...props} />}
            />
            <AdminRoute
              exact
              path="/admin/events/reports/spectatorsList/:id"
              component={(props) =>
                process.env.REACT_APP_PLATFORM !== 'tickethoss' ? (
                  width > 860 ? (
                    <Participants {...props} />
                  ) : (
                    <ParticipantsListMobile {...props} />
                  )
                ) : width > 860 ? (
                  <Tickets {...props} />
                ) : (
                  <TicketsListMobile {...props} />
                )
              }
            />
            <AdminRoute
              exact
              path="/admin/events/reports/ticketBreakdown/:id"
              component={(props) => <TicketBreakdownReport {...props} />}
            />
            <AdminRoute
              exact
              path="/admin/events/reports/posCashReport/:id"
              component={(props) => <PosCashReport {...props} />}
            />
            <AdminRoute
              exact
              path="/admin/events/reports/posCardReport/:id"
              component={(props) => <PosCardReport {...props} />}
            />
            <AdminRoute
              exact
              path="/admin/events/reports/appReport/:id"
              component={(props) => <AppReport {...props} />}
            />
            <AdminRoute
              exact
              path="/admin/events/reports/lapSponsorshipReport/:id"
              component={(props) => <LapSponsorshipReport {...props} />}
            />
            <AdminRoute
              exact
              path="/admin/events/posSettings/:id"
              component={(props) => <PosSettings {...props} />}
            />
            <AdminRoute
              exact
              path="/admin/events/cashDrawerReport/:id"
              component={(props) => <CashDrawerReport {...props} />}
            />
            <AdminRoute
              exact
              path="/admin/events/boxOfficeReport/:id"
              component={(props) => <BoxOfficeReport {...props} />}
            />
            <AdminRoute
              exact
              path="/admin/events/reports/scanLogReport/:id"
              component={(props) => <ScanLogReport {...props} />}
            />
            {/* Track Admin */}
            <TrackAdminRoute
              path="/admin-track/stripe"
              component={StripeRedirect}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/connect/refresh"
              component={StripeConnectRefresh}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/connect/return"
              component={StripeConnectReturn}
            />
            <TrackAdminRoute
              path="/admin-track/style-guide"
              component={StyleGuide}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/learning-hub"
              component={LearningHub}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/home"
              component={TrackHome}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/users/editUser/:id"
              component={UserEdit}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/users/edit/:id"
              component={UserEdit}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/account/:accountId/events"
              component={AccountEvents}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/events/upcoming"
              component={(props) => <EventsV3 {...props} filter="upcoming" />}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/events/past"
              component={(props) => <EventsV3 {...props} filter="past" />}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/events/addEvent"
              component={CreateEventV2}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/events/addEvent/:eventId/tickets"
              component={CreateEventTickets}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/events/addEvent/:eventId/finish"
              component={CreateEventFinish}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/events/editEvent/:eventId/tickets/add"
              component={AddEventTicket}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/events/editEvent/:eventId/tickets/:ticketId/edit"
              component={EditEventTicket}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/events/editEvent/:id"
              component={EditEventV2}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/guest-lists"
              component={(props) =>
                width > 860 ? (
                  <GuestEvents {...props} />
                ) : (
                  <GuestEventsMobile {...props} />
                )
              }
            />
            <TrackAdminRoute
              exact
              path="/admin-track/guest-lists/event/:eventId"
              component={(props) =>
                width > 860 ? (
                  <GuestListDesktop {...props} />
                ) : (
                  <GuestListMobile {...props} />
                )
              }
            />
            <TrackAdminRoute
              exact
              path="/admin-track/guest-lists/event/:eventId/guest/:guestId"
              component={(props) =>
                width > 860 ? (
                  <GuestDetail {...props} />
                ) : (
                  <GuestDetail {...props} />
                )
              }
            />
            <TrackAdminRoute
              exact
              path="/admin-track/guests"
              component={(props) => <Guests {...props} />}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/guests/:guestId"
              component={GuestDetail}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/track/:track_id/events/:id/participants"
              component={(props) =>
                process.env.REACT_APP_PLATFORM !== 'tickethoss' ? (
                  width > 860 ? (
                    <Participants {...props} />
                  ) : (
                    <ParticipantsListMobile {...props} />
                  )
                ) : width > 860 ? (
                  <Tickets {...props} />
                ) : (
                  <TicketsListMobile {...props} />
                )
              }
            />
            <TrackAdminRoute
              exact
              path="/admin-track/track/:track_id/events/:id/participants/:userId"
              component={(props) =>
                process.env.REACT_APP_PLATFORM !== 'tickethoss' ? (
                  <EventParticipantDetail {...props} />
                ) : (
                  <TicketDetails {...props} />
                )
              }
            />
            <TrackAdminRoute
              exact
              path="/admin-track/employees"
              component={(props) =>
                width > 860 ? (
                  <EmployeesTrack {...props} />
                ) : (
                  <EmployeeList {...props} />
                )
              }
            />
            <TrackAdminRoute
              exact
              path="/admin-track/employees/addEmployee"
              component={EmployeeEdit}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/employees/editEmployee/:id"
              component={EmployeeEdit}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/employees/:employee_id"
              component={EmployeeDetail}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/promos"
              component={Promos}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/promos/:promo_id"
              component={PromoDetail}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/settings/:tab"
              component={Account}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/scan/:id"
              component={ScanEmployee}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/notifications"
              component={TrackNotifications}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/faqs"
              component={(props) => <Faqs {...props} />}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/weather"
              component={TrackWeather}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/weather/:trackId"
              component={TrackWeather}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/training"
              component={(props) =>
                width > 860 ? (
                  <TrackVideos {...props} />
                ) : (
                  <TrackVideosMobile {...props} />
                )
              }
            />
            <TrackAdminRoute
              exact
              path="/admin-track/contact"
              component={TrackContact}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/terms-of-service/:type"
              component={TermsOfService}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/openCredits"
              component={(props) =>
                width > 860 ? (
                  <TrackOpenCredits {...props} />
                ) : (
                  <TrackOpenCreditMobile {...props} />
                )
              }
            />
            <TrackAdminRoute
              exact
              path="/admin-track/redeemedCredits"
              component={(props) =>
                width > 860 ? (
                  <TrackRedeemedCredits {...props} />
                ) : (
                  <TrackRedeemedCreditMobile {...props} />
                )
              }
            />
            <TrackAdminRoute
              exact
              path="/admin-track/expiredCredits"
              component={(props) =>
                width > 860 ? (
                  <TrackExpiredCredits {...props} />
                ) : (
                  <TrackExpiredCreditMobile {...props} />
                )
              }
            />
            <TrackAdminRoute
              exact
              path="/admin-track/financials"
              component={(props) =>
                width > 860 ? (
                  <TrackFinancials {...props} />
                ) : (
                  <TrackFinancialsMobile {...props} />
                )
              }
            />
            <TrackAdminRoute
              exact
              path="/admin-track/openCredits/creditDetail/:id"
              component={(props) =>
                width > 860 ? (
                  <TrackOpenCreditsDetail {...props} />
                ) : (
                  <TrackOpenCreditDetailMobile {...props} />
                )
              }
            />
            <TrackAdminRoute
              exact
              path="/admin-track/redeemedCredits/creditDetail/:id"
              component={(props) =>
                width > 860 ? (
                  <TrackRedeemedCreditsDetail {...props} />
                ) : (
                  <TrackRedeemedCreditDetailMobile {...props} />
                )
              }
            />
            <TrackAdminRoute
              exact
              path="/admin-track/expiredCredits/creditDetail/:id"
              component={(props) =>
                width > 860 ? (
                  <TrackExpiredCreditsDetail {...props} />
                ) : (
                  <TrackExpiredCreditDetailMobile {...props} />
                )
              }
            />
            <TrackAdminRoute
              exact
              path="/admin-track/transactions"
              component={(props) =>
                width > 860 ? (
                  <TrackTransactionsEvents {...props} />
                ) : (
                  <MobileTransactions {...props} />
                )
              }
            />
            <TrackAdminRoute
              exact
              path="/admin-track/transactions/detail/:id"
              component={TransactionDetailNew}
            />
            <AdminRoute
              exact
              path="/admin/transactions/detail/:id"
              component={TransactionDetailNew}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/transactions/event/:id"
              component={(props) =>
                width > 860 ? (
                  <Transactions {...props} />
                ) : (
                  <MobileTransactionsList {...props} />
                )
              }
            />
            <TrackAdminRoute
              exact
              path="/admin-track/registrations"
              component={(props) =>
                width > 860 ? (
                  <TrackRegistrationsEventsDesktop {...props} />
                ) : (
                  <TrackRegistrationsEventsMobile {...props} />
                )
              }
            />
            <TrackAdminRoute
              exact
              path="/admin-track/registrations/event/:id"
              component={(props) =>
                width > 860 ? (
                  <RegistrationsDesktop {...props} />
                ) : (
                  <RegistrationsMobile {...props} />
                )
              }
            />
            <TrackAdminRoute
              exact
              path="/admin-track/users"
              component={Customers}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/users/transactions/:id"
              component={CustomerDetail}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/customers/issue-credit/:customerId"
              component={IssueCredit}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/customers/issue-refund/:customerId"
              component={IssueRefund}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/customers/send-campaign"
              component={SendCampaign}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/transactions/:transactionId/credit"
              component={TransactionCredit}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/transactions/:transactionId/refund"
              component={TransactionRefund}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/annualPurchases"
              component={PurchasesPage}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/annualPurchases/purchase/:id"
              component={PurchaseDetailPage}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/annualMembers"
              component={MembersPage}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/annualMembersDetail/member/:id"
              component={MemberDetail}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/transferMembership/:id"
              component={TransferMembership}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/annualUsers"
              component={AnnualsPage}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/annualsDetail/member/:id"
              component={AnnualDetail}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/annualDetail/annual/:id"
              component={AnnualDetail}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/print"
              render={(props) => <PrintParticipants {...props} />}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/registrationDetail/registration/:id"
              component={MemberDetail}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/cart/:id"
              component={CartPage}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/events/menu/:id"
              component={(props) => <EventsMenu {...props} />}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/events/reports/:id"
              component={(props) => <EventsReport {...props} />}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/events/refund/:id"
              component={(props) => (
                <RefundEventFlow {...props} isVisible={true} />
              )}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/events/reservedSeats/:id"
              component={(props) => <ReservedSeats {...props} />}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/events/reports/spectatorsList/:id"
              component={(props) =>
                process.env.REACT_APP_PLATFORM !== 'tickethoss' ? (
                  width > 860 ? (
                    <Participants {...props} />
                  ) : (
                    <ParticipantsListMobile {...props} />
                  )
                ) : width > 860 ? (
                  <Tickets {...props} />
                ) : (
                  <TicketsListMobile {...props} />
                )
              }
            />
            <TrackAdminRoute
              exact
              path="/admin-track/events/reports/posCashReport/:id"
              component={(props) => <PosCashReport {...props} />}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/events/reports/posCardReport/:id"
              component={(props) => <PosCardReport {...props} />}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/events/reports/appReport/:id"
              component={(props) => <AppReport {...props} />}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/events/reports/ticketBreakdown/:id"
              component={(props) => <TicketBreakdownReport {...props} />}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/events/reports/lapSponsorshipReport/:id"
              component={(props) => <LapSponsorshipReport {...props} />}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/events/posSettings/:id"
              component={(props) => <PosSettings {...props} />}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/events/cashDrawerReport/:id"
              component={(props) => <CashDrawerReport {...props} />}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/events/boxOfficeReport/:id"
              component={(props) => <BoxOfficeReport {...props} />}
            />
            <TrackAdminRoute
              exact
              path="/admin-track/events/reports/scanLogReport/:id"
              component={(props) => <ScanLogReport {...props} />}
            />
            {/* Employee  Admin */}
            <EmployeeRoute
              path="/admin-employee/style-guide"
              component={StyleGuide}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/learning-hub"
              component={LearningHub}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/home"
              component={TrackHome}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/users/editUser/:id"
              component={UserEdit}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/users/edit/:id"
              component={UserEdit}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/account/:accountId/events"
              component={AccountEvents}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/events/upcoming"
              component={(props) => <EventsV3 {...props} filter="upcoming" />}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/events/past"
              component={(props) => <EventsV3 {...props} filter="past" />}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/events/addEvent"
              component={CreateEventV2}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/events/addEvent/:eventId/tickets"
              component={CreateEventTickets}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/events/addEvent/:eventId/finish"
              component={CreateEventFinish}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/events/editEvent/:eventId/tickets/add"
              component={AddEventTicket}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/events/editEvent/:eventId/tickets/:ticketId/edit"
              component={EditEventTicket}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/events/editEvent/:id"
              component={EditEventV2}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/weather"
              component={TrackWeather}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/weather/:trackId"
              component={TrackWeather}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/guest-lists"
              component={(props) =>
                width > 860 ? (
                  <GuestEvents {...props} />
                ) : (
                  <GuestEventsMobile {...props} />
                )
              }
            />
            <EmployeeRoute
              exact
              path="/admin-employee/guest-lists/event/:eventId"
              component={(props) =>
                width > 860 ? (
                  <GuestListDesktop {...props} />
                ) : (
                  <GuestListMobile {...props} />
                )
              }
            />
            <EmployeeRoute
              exact
              path="/admin-employee/guest-lists/event/:eventId/guest/:guestId"
              component={(props) =>
                width > 860 ? (
                  <GuestDetail {...props} />
                ) : (
                  <GuestDetail {...props} />
                )
              }
            />
            <EmployeeRoute
              exact
              path="/admin-employee/guests"
              component={(props) => <Guests {...props} />}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/guests/:guestId"
              component={GuestDetail}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/guest-lists"
              component={GuestEventsMobile}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/guest-lists/event/:eventId"
              component={GuestListMobile}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/guest-lists/event/:eventId/guest/:guestId"
              component={GuestDetail}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/promos"
              component={Promos}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/openCredits"
              component={(props) =>
                width > 860 ? (
                  <TrackOpenCredits {...props} />
                ) : (
                  <TrackOpenCreditMobile {...props} />
                )
              }
            />
            <EmployeeRoute
              exact
              path="/admin-employee/redeemedCredits"
              component={(props) =>
                width > 860 ? (
                  <TrackRedeemedCredits {...props} />
                ) : (
                  <TrackRedeemedCreditMobile {...props} />
                )
              }
            />
            <EmployeeRoute
              exact
              path="/admin-employee/expiredCredits"
              component={(props) =>
                width > 860 ? (
                  <TrackExpiredCredits {...props} />
                ) : (
                  <TrackExpiredCreditMobile {...props} />
                )
              }
            />
            <EmployeeRoute
              exact
              path="/admin-employee/financials"
              component={(props) =>
                width > 860 ? (
                  <TrackFinancials {...props} />
                ) : (
                  <TrackFinancialsMobile {...props} />
                )
              }
            />
            <EmployeeRoute
              exact
              path="/admin-employee/openCredits/creditDetail/:id"
              component={(props) =>
                width > 860 ? (
                  <TrackOpenCreditsDetail {...props} />
                ) : (
                  <TrackOpenCreditDetailMobile {...props} />
                )
              }
            />
            <EmployeeRoute
              exact
              path="/admin-employee/redeemedCredits/creditDetail/:id"
              component={(props) =>
                width > 860 ? (
                  <TrackRedeemedCreditsDetail {...props} />
                ) : (
                  <TrackRedeemedCreditDetailMobile {...props} />
                )
              }
            />
            <EmployeeRoute
              exact
              path="/admin-employee/expiredCredits/creditDetail/:id"
              component={(props) =>
                width > 860 ? (
                  <TrackExpiredCreditsDetail {...props} />
                ) : (
                  <TrackExpiredCreditDetailMobile {...props} />
                )
              }
            />
            <EmployeeRoute
              exact
              path="/admin-employee/guest-lists"
              component={GuestEventsMobile}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/guests"
              component={(props) => <Guests {...props} />}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/guests/:guestId"
              component={GuestDetail}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/guest-lists/event/:eventId"
              component={GuestListMobile}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/guest-lists/event/:eventId/guest/:guestId"
              component={GuestDetail}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/track/:track_id/events/:id/participants"
              component={(props) =>
                process.env.REACT_APP_PLATFORM !== 'tickethoss' ? (
                  width > 860 ? (
                    <Participants {...props} />
                  ) : (
                    <ParticipantsListMobile {...props} />
                  )
                ) : width > 860 ? (
                  <Tickets {...props} />
                ) : (
                  <TicketsListMobile {...props} />
                )
              }
            />
            <EmployeeRoute
              exact
              path="/admin-employee/notifications"
              component={TrackNotifications}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/track/:track_id/events/:id/participants/:userId"
              component={(props) =>
                process.env.REACT_APP_PLATFORM !== 'tickethoss' ? (
                  <EventParticipantDetail {...props} />
                ) : (
                  <TicketDetails {...props} />
                )
              }
            />
            <EmployeeRoute
              exact
              path="/admin-employee/scan/:id"
              component={ScanEmployee}
            />
            <EmployeeRoute exact path="/admin-employee/faqs" component={Faqs} />
            <EmployeeRoute
              exact
              path="/admin-employee/contact"
              component={TrackContact}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/terms-of-service/:type"
              component={TermsOfService}
            />
            <EmployeeRoute
              backgroundColor="#fff"
              exact
              path="/admin-employee/settings/:tab"
              component={Account}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/transactions"
              component={(props) =>
                width > 860 ? (
                  <TrackTransactionsEvents {...props} />
                ) : (
                  <MobileTransactions {...props} />
                )
              }
            />
            <EmployeeRoute
              exact
              path="/admin-employee/transactions/detail/:id"
              component={TransactionDetailNew}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/transactions/event/:id"
              component={(props) =>
                width > 860 ? (
                  <Transactions {...props} />
                ) : (
                  <MobileTransactionsList {...props} />
                )
              }
            />
            <EmployeeRoute
              exact
              path="/admin-employee/registrations"
              component={(props) =>
                width > 860 ? (
                  <TrackRegistrationsEventsDesktop {...props} />
                ) : (
                  <TrackRegistrationsEventsMobile {...props} />
                )
              }
            />
            <EmployeeRoute
              exact
              path="/admin-employee/users"
              component={Customers}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/users/transactions/:id"
              component={CustomerDetail}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/customers/issue-credit/:customerId"
              component={IssueCredit}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/customers/issue-refund/:customerId"
              component={IssueRefund}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/customers/send-campaign"
              component={SendCampaign}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/transactions/:transactionId/credit"
              component={TransactionCredit}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/transactions/:transactionId/refund"
              component={TransactionRefund}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/employees"
              component={EmployeesTrack}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/employees/addEmployee"
              component={EmployeeEdit}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/employees/editEmployee/:id"
              component={EmployeeEdit}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/employees/:employee_id"
              component={EmployeeDetail}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/contact"
              component={TrackContact}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/terms-of-service/:type"
              component={TermsOfService}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/annualPurchases"
              component={PurchasesPage}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/annualPurchases/purchase/:id"
              component={PurchaseDetailPage}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/annualMembers"
              component={MembersPage}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/annualsDetail/member/:id"
              component={AnnualDetail}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/annualDetail/annual/:id"
              component={AnnualDetail}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/annualUsers"
              component={AnnualsPage}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/annualMembersDetail/member/:id"
              component={MemberDetail}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/transferMembership/:id"
              component={TransferMembership}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/registrations"
              component={(props) =>
                width > 860 ? (
                  <TrackRegistrationsEventsDesktop {...props} />
                ) : (
                  <TrackRegistrationsEventsMobile {...props} />
                )
              }
            />
            <EmployeeRoute
              exact
              path="/admin-employee/registrations/event/:id"
              component={(props) =>
                width > 860 ? (
                  <RegistrationsDesktop {...props} />
                ) : (
                  <RegistrationsMobile {...props} />
                )
              }
            />
            <EmployeeRoute
              exact
              path="/admin-employee/registrationDetail/registration/:id"
              component={MemberDetail}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/cart/:id"
              component={CartPage}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/events/menu/:id"
              component={(props) => <EventsMenu {...props} />}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/events/reports/:id"
              component={(props) => <EventsReport {...props} />}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/events/refund/:id"
              component={(props) => (
                <RefundEventFlow {...props} isVisible={true} />
              )}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/events/reservedSeats/:id"
              component={(props) => <ReservedSeats {...props} />}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/events/reports/lapSponsorshipReport/:id"
              component={(props) => <LapSponsorshipReport {...props} />}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/events/reports/spectatorsList/:id"
              component={(props) =>
                process.env.REACT_APP_PLATFORM !== 'tickethoss' ? (
                  width > 860 ? (
                    <Participants {...props} />
                  ) : (
                    <ParticipantsListMobile {...props} />
                  )
                ) : width > 860 ? (
                  <Tickets {...props} />
                ) : (
                  <TicketsListMobile {...props} />
                )
              }
            />
            <EmployeeRoute
              exact
              path="/admin-employee/events/reports/ticketBreakdown/:id"
              component={(props) => <TicketBreakdownReport {...props} />}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/events/reports/posCashReport/:id"
              component={(props) => <PosCashReport {...props} />}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/events/reports/posCardReport/:id"
              component={(props) => <PosCardReport {...props} />}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/events/reports/appReport/:id"
              component={(props) => <AppReport {...props} />}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/events/posSettings/:id"
              component={(props) => <PosSettings {...props} />}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/events/cashDrawerReport/:id"
              component={(props) => <CashDrawerReport {...props} />}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/events/boxOfficeReport/:id"
              component={(props) => <BoxOfficeReport {...props} />}
            />
            <EmployeeRoute
              exact
              path="/admin-employee/events/reports/scanLogReport/:id"
              component={(props) => <ScanLogReport {...props} />}
            />
            {/* used as a catch all redirect */}
            <AuthRoute component={Auth} />
          </Switch>
          <GlobalStyle appTheme={state.theme} width={width} />
        </Router>
      </ThemeProvider>
    </Apollo>
  );
};

export default AppRouter;
